var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { useInternationalization } from '@progress/kendo-react-intl';
import { classNames, Keys } from '@progress/kendo-react-common';
import { getNestedValue } from '../utils';
import { useTableKeyboardNavigation } from '@progress/kendo-react-data-tools';
import { TREELIST_COL_INDEX_ATTRIBUTE, TREELIST_PREVENT_SELECTION_ELEMENT } from '../constants';
export var TreeListCell = function (props) {
    var _a, _b, _c;
    var hasChildren = props.hasChildren, _d = props.level, level = _d === void 0 ? [0] : _d, expanded = props.expanded, dataItem = props.dataItem, format = props.format, id = props.id, ariaColumnIndex = props.ariaColumnIndex, isSelected = props.isSelected;
    var data = getNestedValue(props.field, dataItem);
    var intl = useInternationalization();
    var navigationAttributes = useTableKeyboardNavigation(id);
    var dataAsString = '';
    var onKeyDownHandler = React.useCallback(function (event) {
        if (event.isDefaultPrevented()) {
            return;
        }
        if (event.keyCode === Keys.enter && props.expandable) {
            event.preventDefault();
            props.onExpandChange(event, dataItem, level);
        }
    }, [props.expandable, dataItem, level]);
    if (data !== undefined && data !== null) {
        dataAsString = format ?
            intl.format(format, data) :
            data.toString();
    }
    var icons = [];
    if (props.expandable) {
        icons.push.apply(icons, level.slice(1).map(function (_x, i) { return (React.createElement("span", { className: "k-icon k-i-none", key: i })); }));
        if (hasChildren) {
            icons.push(React.createElement("span", __assign({ className: "k-icon k-i-".concat(expanded ? 'collapse' : 'expand'), key: "expand-collapse", onClick: function (event) { return props.onExpandChange(event, dataItem, level); } }, (_a = {}, _a[TREELIST_PREVENT_SELECTION_ELEMENT] = true, _a))));
        }
        else {
            icons.push(React.createElement("span", { className: "k-icon k-i-none", key: icons.length }));
        }
    }
    var defaultRendering = (React.createElement("td", __assign({ style: props.style, className: classNames(props.className, (_b = {},
            _b['k-text-nowrap'] = props.expandable,
            _b['k-selected'] = isSelected,
            _b)), colSpan: props.colSpan, "aria-colindex": ariaColumnIndex, "aria-expanded": hasChildren ? expanded : undefined, "aria-selected": isSelected, role: 'gridcell', onKeyDown: onKeyDownHandler }, (_c = {}, _c[TREELIST_COL_INDEX_ATTRIBUTE] = props.colIndex, _c), navigationAttributes),
        icons,
        dataAsString));
    return props.render ?
        props.render.call(undefined, defaultRendering, props) :
        defaultRendering;
};
TreeListCell.displayName = 'KendoReactTreeListCell';
